import type { Invoice } from './invoice.type.ts';
export interface InvoiceExtension extends Invoice {}
export class InvoiceExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get canAddLineItems() {
    // return this.invoiceType === 'CONTRIBUTION' && this.canEditLineItems;

    // Legacy invoices are read only for now
    return false;
  }

  get canEditLineItems() {
    // return ['CREATED', 'APPROVED'].includes(this.status);

    // Legacy invoices are read only for now
    return false;
  }
}

const Registration = {
  kind: 'object',
  name: 'invoice',
  features: InvoiceExtension,
};
export default Registration;
